export default __webpack_public_path__ + "static/SuisseIntl-ThinItalic-1413866634d8898471928027f84c1d3a.woff2";